import { ENV } from 'config/env';

export const createCmsApiBaseUrl = (): string => ENV.CMS_API_BASE_URL;
export const createCmsAssetUrl = (assetId: string): string => `https://direct.energy5.com/${assetId}`;
